import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import { FilterContext } from 'context/Context';
import { colors } from 'helpers/utils';
import React, { useContext, useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ServiceCatalogService from 'services/ServiceCatalog.service';
import PizzaChart from './Pie';

const TicketsByCatalog = ({ data, title, filtersDash }) => {
  const { setFilters } = useContext(FilterContext);
  const navigate = useNavigate();
  const [catalogs, setCatalogs] = useState([]);

  useEffect(() => {
    const fetchCatalogs = async () => {
      try {
        const response = await ServiceCatalogService.list('size=1000');
        if (response.content) {
          setCatalogs(response.content);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchCatalogs();
  }, []);

  const processFilterArray = (value) => {
    if (Array.isArray(value) && value.length > 0) {
      return value.map(v => {
        const parsed = parseInt(v, 10);
        return isNaN(parsed) ? v : parsed;
      });
    }
    return value || '';
  };

  const handleClick = params => {
    const { name } = params;
    const catalog = catalogs.find(
      c => c.name.trim().toLowerCase() === name.trim().toLowerCase()
    );
    if (catalog) {
      setFilters({
        page: 0,
        size: 20,
        code: '',
        priorities: filtersDash.priority || '',
        status: ['TO_DO', 'IN_PROGRESS', 'PENDING'],
        customer: processFilterArray(filtersDash.customer),
        serviceCatalog: [catalog.id],
        category: '',
        subcategory: '',
        subject: '',
        agent: processFilterArray(filtersDash.agent),
        serviceGroup: processFilterArray(filtersDash.serviceGroup),
        typeTicket: '',
        initialCreationDate: filtersDash.initialCreationDate || '',
        endCreationDate: filtersDash.endCreationDate || '',
        initialSolutionDate: '',
        endSolutionDate: '',
        statusSlaResponse: '',
        statusSlaSolution: '',
        createdBy: '',
        defaultFilter: ''
      });
      navigate('/tickets');
    }
  };

  return (
    <Card className="h-100">
      <FalconCardHeader title={title} titleTag="h4" className="py-2" />
      <Card.Body className="p-3 d-flex align-items-center">
        <Row className="w-100">
          <Col lg={8} xs={12}>
            {data && <PizzaChart data={data} onClick={handleClick} />}
          </Col>

          <Col lg={4} xs={12} className="h-100 scroll-area">
            <div style={{ height: '300px', overflowY: 'scroll' }}>
              <h6 className="mb-3">Resumo</h6>
              <div>
                {data &&
                  data.map((item, i) => (
                    <div key={item.name}>
                      <Flex>
                        <FontAwesomeIcon
                          icon={faCircle}
                          color={colors[i]}
                          size="sm"
                        />
                        <h6
                          className="m-0 p-0 ms-1 text-nowrap overflow-hidden"
                          style={{ textOverflow: 'ellipsis' }}
                        >
                          {item.name}
                        </h6>
                      </Flex>
                      <p className="fs-10">Tickets {item.value}</p>
                    </div>
                  ))}
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default TicketsByCatalog;
